import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  TeachersGrid
} from "./LearningActivity.styles";
import { TeacherCard } from "./TeacherCard.component";
import { TitleAndSubtitle } from "../../components/Commons/TitleAndSubtitle.component";
import type { Teacher } from "../../types";

export type TeacherWithRole = Teacher & { role: string }

type ITeachersContent = {
  teachers: TeacherWithRole[]
  title?: string
  subTitle?: string
}

export const TeachersContent = ({ teachers, title, subTitle }: ITeachersContent) => {
  const { t } = useTranslation();

  return (
    <Stack width="100%">
      <TitleAndSubtitle
        title={ title }
        subTitle={ subTitle }
        sxSubTitle={ {
          marginBottom:"0.75rem"
        } }
      /> 
      <TeachersGrid role="list">
        { teachers.map((person, idx) => (
          <TeacherCard
            aria-label={ `${person.completeName}. ${t("role")}:${person.role}` }
            key={ `${person.id}-${idx}` }
            image={ person.image }
            name={ person.completeName || "" }
            role={ person.role }
          />
        )) }
      </TeachersGrid>
    </Stack>
  );
};
